import { useQuery, UseQueryResult } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Dayjs } from 'dayjs';
import {CORE_API_SUFFIX, dataFetch, DIGGER_API_SUFFIX} from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';
import { ApiError, ApiResponse } from '../../../interfaces/apiResponse.type';

const useGetLinkedIn = (
    identifier: string,
): UseQueryResult<ApiResponse<string>, ApiError<null>> => {
    const navigate = useNavigate();

    const queryParams = new URLSearchParams();

    const queryKey = generateQueryKey(identifier, queryParams);

    return useQuery<ApiResponse<string>, ApiError<null>>(
        [`linked_in_${queryKey}`],
        () => dataFetch.get(`${DIGGER_API_SUFFIX}linkedin/redirect?${queryParams}`),
        {
            onSuccess: (response) => {
                window.location.replace(`${response.data.data}`);
            },
            enabled: false,
        },
    );
};

export default useGetLinkedIn;
